import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";

import InfiniteScroll from "react-infinite-scroller";
import axios from "axios";
import config from "../config";
import Field from "../sections/MUI/Field";
import Icon from "../sections/MUI/Icon";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class Orders extends Component {

    state = {
        orders: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        search: "",
        code: ""
    };

    getOrders(page, code = "", search = "") {
        axios.get(`${config.api}/admin/orders?token=${config.token}&page=${page}&s=${search}&code=${code}`)
            .then(r => {
                const orders = r.data.result;

                this.setState({
                    orders: page > 1 ? [...this.state.orders, ...orders.docs] : orders.docs,
                    page: page + 1,
                    hasNextPage: orders.hasNextPage,
                    totalPages: orders.totalPages
                });
            })
            .catch(err => {
                config.handleError(err);
            });
    }


    statusColor(status = "ثبت اولیه") {
        let c = "#ffffff";
        switch (status) {
            case  "کنسل شده":
                c = "rgba(255,0,0,0.18)";
                break;
            case "در حال اعزام":
            case "در مسیر":
            case "در محل":
                c = "rgba(255,166,0,0.18)";
                break;
            case "پایان کار":
            case "خروج":
                c = "rgba(8,255,0,0.18)";
                break;
            default:
                c = "#ffffff"
                break;
        }

        return c;
    }

    copy(o) {
        try {
            if (o) {
                let txt = "";
                let {
                    code, address, dateTime, food,
                    niroo, description, user,
                    tel, service,
                    options, gadgets,
                    status
                } = o;
                food = food ? "غذا با کارفرما است" : "غذا با شرکت است";
                const fullName = user ? user.firstName + " " + user.lastName : "";
                const phoneNumber = user ? user.phoneNumber : ""
                service = service ? service.title.toString().trim() : ""

                let strOptions = "";
                let strGadgets = "";

                options.map(o => {
                    strOptions = strOptions + `${o.t} ${o.v}\n`;
                });

                gadgets.map(g => {
                    strGadgets = strGadgets + `- ${g}\n`;
                });

                txt = `🆔 ${code}\n`
                    + `🔄 ${status}\n`
                    + `📅 ${dateTime}\n`
                    + "---------------------\n"
                    + `توضیحات: ${description}\n`
                    + `مشتری: ${fullName}\n`
                    + `آدرس: ${address}\n`
                    + `شماره موبایل: ${phoneNumber}\n`
                    + `تلفن ضروری: ${tel}\n`
                    + `خدمت: ${service}\n`
                    + `تعداد نیرو: ${niroo}\n`
                    + `غذا: ${food}\n\n`
                    + `گزینه ها:\n${strOptions}\n${strGadgets}`
                navigator.clipboard.writeText(txt);
                toast.success("کپی شد!");
            }
        } catch (err) {
            console.error(err);
        }

    }

    render() {
        const {orders, page, hasNextPage, totalPages, search, code} = this.state;
        return (
            <div className="orders-list">
                <Back {...this.props}/>
                <div className="row">
                    <div className="col-md-5">
                        <Button submit={false} onClick={() => this.props.navigate("/order/new")}
                                icon="plus">ثبت سفارش</Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <Field name="search"
                               value={search}
                               label="جستجو"
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.getOrders(1, code, value);
                               }}/>
                    </div>
                    <div className="col-5">
                        <Field name="code"
                               type="number"
                               value={code}
                               label="کد سفارش"
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.getOrders(1, value, search);
                               }}/>
                    </div>
                </div>

                <br/>
                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getOrders(page, code, search)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            orders ? orders?.map((o, i) =>
                                <article key={"order" + i} style={{backgroundColor: this.statusColor(o.status)}}>
                                    <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <p className="code">#{o.code}</p>
                                                <p className="status">{o.status}</p>
                                            </div>
                                            {o.user ?
                                                <div className="user">
                                                    <p className="user-full-name">
                                                        <span>{o.user.firstName}</span>&nbsp;
                                                        <span>{o.user.lastName}</span>&nbsp;
                                                        <span>({o.user.phoneNumber})</span></p>
                                                </div>
                                                : null}

                                            <p className="niroo">تعداد نیرو:&nbsp;{o.niroo}</p>
                                            {o.service ?
                                                <div className="service">
                                                    <div className="row">
                                                        <div className="col-auto">
                                                            <div className="service-image">
                                                                <img src={o.service.image} alt=""/>
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <p className="service-title">{o.service.title}</p>
                                                        </div>

                                                    </div>
                                                </div>
                                                : null
                                            }
                                            {o.region ?
                                                <div className="region">محله:&nbsp;{o.region.title}</div>
                                                : null}
                                            {o.expert ?
                                                <div className="expert">
                                                    <div className="row">
                                                        <div className="col-auto">
                                                            <div className="expert-image">
                                                                <img src={o.expert.image} alt=""/>
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <p className="expert-full-name">
                                                                <span>{o.expert.firstName}</span>&nbsp;
                                                                <span>{o.expert.lastName}</span>&nbsp;
                                                                <span>({o.expert.phoneNumber})</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="info">
                                                <p><span>مدت زمان:</span><span>{o.time}</span></p>
                                                <p><span>تاریخ و ساعت:</span><span>{o.dateTime}</span></p>
                                                <p><span>آدرس:</span><span>{o.address}</span></p>
                                            </div>


                                            <div className="food" style={{padding: 4, fontSize: "11pt"}}>
                                                {o.food ? "غذا با شرکت است" : "غذا با کارفرما است"}
                                            </div>

                                        </div>
                                        <div className="col-auto">
                                            <Icon i="copy" className="copy-icon"
                                                  onClick={() => this.copy(o)}/>
                                            <Icon i="edit" className="edit-icon"
                                                  onClick={() => this.props.navigate(`/order/${o.id}`)}/>

                                        </div>
                                    </div>
                                </article>
                            ) : null
                        }
                    </InfiniteScroll>
                </div>
            </div>
        );
    }
}

export default gpn(Orders);